const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  variantChange: 'variant-change'
};


document.addEventListener('DOMContentLoaded', function () {
  const multicolumnSection = document.querySelector(
    '#shopify-section-template--19959925375107__multicolumn_4rC8dH'
  );

  const richTextSection = document.querySelector(
    '#shopify-section-template--19959925375107__rich_text_pgYBjC'
  );

  if (!multicolumnSection || !richTextSection) return;

  const ul = multicolumnSection.querySelector('.slider-mobile-gutter > ul');


  if (!ul || ul.children.length === 0) {
    richTextSection.style.display = 'none';
  }
});


